import { render } from "./NotesViewController.vue?vue&type=template&id=d635f728"
import script from "./NotesViewController.vue?vue&type=script&lang=js"
export * from "./NotesViewController.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__